import { Component, OnInit, Input } from '@angular/core';
import { camps } from '../../../../models/models.generated';

@Component({
    selector: 'app-transaction-report-item',
    templateUrl: './transaction-report-item.component.html',
    styleUrls: ['./transaction-report-item.component.scss'],
    standalone: false
})
export class TransactionReportItemComponent implements OnInit {

    @Input() public item: camps.TransactionReportInfoItem;

    constructor() { }

    ngOnInit() {
    }

}
